import WorkTitle from "./WorkTitle";
import Writing from "./Writing";

const Writings = () => {
  return (
    <div>
      <WorkTitle title="MY WRITINGS" />
      <Writing />
    </div>
  );
};

export default Writings;
